import React from 'react'
import AboutUs from './AboutUs'
import Blog from './Blog'
import ContactUs from './ContactUs'
import FAQ from './FAQ'
import FeatureContainer from './FeatureContainer'
import Footer from './Footer'
import HomeContainer from './HomeContainer'
import Portfolio from './Portfolio'
import Services from './Services'

const mainContainer = () => {
  return (
    <>
      <div className=' px-16'>
        <HomeContainer />
        <FeatureContainer />
        <AboutUs />
        <Services />
        <FAQ/>
        <Portfolio />
        <Blog/>
      </div>
      
      <ContactUs />
      
      <Footer />
    </>
  )
}

export default mainContainer